import { render, staticRenderFns } from "./TicketPrint.vue?vue&type=template&id=53e5a130&scoped=true&"
import script from "./TicketPrint.vue?vue&type=script&lang=js&"
export * from "./TicketPrint.vue?vue&type=script&lang=js&"
import style0 from "./TicketPrint.vue?vue&type=style&index=0&id=53e5a130&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e5a130",
  null
  
)

export default component.exports